import baseFetch, {
    // createParamString
  } from '../baseFetch';

// eslint-disable-next-line
export const fetchCMSMenuLocations = async () =>
  baseFetch('api/cms/menus/Locations?');

export const fetchCMSPage = async page =>
  baseFetch(`api/cms/pages/${page}?`);

export const fetchPointOfInterest = coordinates =>
  baseFetch(`api/cms/poi?lat=${coordinates[0]}&lon=${coordinates[1]}`);

export const fetchAllPointsOfInterest = () =>
  baseFetch('api/cms/poi');

export const fetchAllPosts = () =>
  baseFetch('api/cms/posts');

export const fetchNearbyRegionByCoordinates = coordinates =>
  baseFetch(`api/cms/nearbyregion?lat=${coordinates[0]}&lon=${coordinates[1]}`, null, false);

export const fetchRegionBySlug = async slug =>
  baseFetch(`api/cms/regions/${slug}?`);



// WEBPACK FOOTER //
// ./src/common/api/cms.js